<h2 *ngIf="data.title" mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  {{ data.content }}
  <crm-form-field-universal [parentFormGroup]="form" [field]="promptField"></crm-form-field-universal>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container *ngIf="data.selectButton === 'no'">
    <button mat-button [mat-dialog-close]="null">cdkFocusInitial>{{ data.no }}</button>
    &nbsp;&nbsp;
    <button mat-flat-button color="warn" [mat-dialog-close]="form.get('promptField').value" [disabled]="form.invalid">
      {{ data.yes }}
    </button>
  </ng-container>

  <ng-container *ngIf="data.selectButton === 'yes'">
    <button mat-button [mat-dialog-close]="null">{{ data.no }}</button>
    &nbsp;&nbsp;
    <button
      mat-flat-button
      color="warn"
      cdkFocusInitial
      [mat-dialog-close]="form.get('promptField').value"
      [disabled]="form.invalid"
    >
      {{ data.yes }}
    </button>
  </ng-container>
</mat-dialog-actions>
